import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface AchievementFilter {
    mode: string;
    wasteType: any;
    wasteCode: any;
}

export const useAchievementStore = defineStore('achievement', () => {
    const filter = ref<AchievementFilter>();

    const getFilter = ():AchievementFilter => {
        if(filter.value == null) {
            filter.value = {
                mode: 'annual',
                wasteType: null,
                wasteCode: null
            };
        }
        return filter.value;
    }

    return {
        filter,
        getFilter,
    };
});